import React from 'react';

import InventoryHoldNew from '@components/shared/inventory/InventoryHoldNew';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';
import { inventoryHoldService } from '@services/admin/inventoryHoldService';

const InventoryHoldNewPage: React.FC = () => {
  const productService = useAdminProductService();
  const { defaultWarehouseId } = useMerchant();
  // useMerchantData returns null when called outside MerchantDataProvider; admin
  // page tree always provides it, but the hook signature is `T | null` so we
  // defensively coalesce. inventoryTypes itself is always an array, never undefined.
  const merchantData = useMerchantData();
  const inventoryTypes = merchantData?.inventoryTypes ?? [];

  return (
    <InventoryHoldNew
      role="admin"
      service={inventoryHoldService}
      productService={productService}
      inventoryTypes={inventoryTypes}
      defaultWarehouseId={defaultWarehouseId ?? undefined}
    />
  );
};

export default InventoryHoldNewPage;
